import { mutations as billingMutations } from '@/store/billing'
import { mutations as paymentMutations } from '@/store/payment'
import { mutations as interactionMutations } from '@/store/interaction'

const defaultMutations = {};

function registerMutations(mutations) {
	const mutationNames = Object.keys(mutations);
	for (let i in mutationNames) {
		const mutationName = mutationNames[i];
		defaultMutations[mutationName] = mutations[mutationName];
	}
};

registerMutations(billingMutations);
registerMutations(paymentMutations);
registerMutations(interactionMutations);

export default defaultMutations;